import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-peoples",
  "use": "icon-peoples-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-peoples\"><path d=\"M469.333333 469.333333c93.866667 0 170.666667 76.8 170.666667 170.666667v213.333333c0 46.933333-38.4 85.333333-85.333333 85.333334H128c-46.933333 0-85.333333-38.4-85.333333-85.333334v-213.333333c0-93.866667 76.8-170.666667 170.666666-170.666667h256zM704 554.666667H810.666667c93.866667 0 170.666667 76.8 170.666666 170.666666v128c0 46.933333-38.4 85.333333-85.333333 85.333334h-170.666667v-298.666667c0-29.866667-8.533333-59.733333-21.333333-85.333333zM733.866667 256c72.533333 0 128 55.466667 128 128s-55.466667 128-128 128-128-55.466667-128-128 59.733333-128 128-128zM341.333333 85.333333c93.866667 0 170.666667 76.8 170.666667 170.666667s-76.8 170.666667-170.666667 170.666667-170.666667-76.8-170.666666-170.666667 76.8-170.666667 170.666666-170.666667z\" p-id=\"6883\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/peoples.svg
// module id = TgHK
// module chunks = 25